import UIButton from 'UIComponents/button/UIButton';
import MobileNestedMenu from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMyPlaylistsParams } from '../myPlaylistsHooks';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'academy-common-lib/utils/Styling';
import { MY_PLAYLISTS_TABS } from '../myPlaylistsTypes';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import useNavigate from '../../../hooks/useNavigate';
import { getMyPlaylistsUrl } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Caret = styled(UIIcon).attrs({
  className: 'm-left-1',
  name: 'downCarat'
}).withConfig({
  displayName: "MyPlaylistsTabNavigationMobile__Caret",
  componentId: "sc-70eebx-0"
})(["font-size:12px;"]);
export const MyPlaylistsTabNavigationMobile = () => {
  const {
    isShowing,
    show,
    hide,
    toggle
  } = useToggle();
  const {
    tab: selectedTab
  } = useMyPlaylistsParams();
  const navigate = useNavigate();
  const handleOnClick = tab => {
    hide();
    navigate(getMyPlaylistsUrl({
      tab
    }));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIButton, {
      onClick: show,
      use: "link",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.myPlaylistsType.${selectedTab}`
      }), /*#__PURE__*/_jsx(Caret, {})]
    }), isShowing && /*#__PURE__*/_jsxs(MobileNestedMenu, {
      indented: false,
      open: true,
      setIsOpen: toggle,
      useBackText: true,
      useSidePanel: true,
      children: [/*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.topFilters.myPlaylistsType.filterTitle"
        })
      }), MY_PLAYLISTS_TABS.map(tab => /*#__PURE__*/_jsx(MenuRow, {
        onClick: () => handleOnClick(tab),
        style: {
          fontWeight: tab === selectedTab ? 500 : 400
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.myPlaylistsType.${tab}`
        })
      }, `my_playlists_tab_mobile_${tab}`))]
    })]
  });
};
export default MyPlaylistsTabNavigationMobile;